import { render, staticRenderFns } from "./TrainingOverview.vue?vue&type=template&id=d772be98&scoped=true&"
import script from "./TrainingOverview.vue?vue&type=script&lang=js&"
export * from "./TrainingOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d772be98",
  null
  
)

export default component.exports